import {Route} from "@angular/router";
import {guardTrainingGroupsWatch} from "@/app/routes/guards/training-groups-guard";

const NAME = 'Этапы подготовки'

export const trainingGroups: Route[] = [
    {
        path: 'traininggroups',
        loadComponent: () => import('@components/guides/trainingGroups/trainingGroups.component').then(c => c.TrainingGroupsComponent),
        canActivate: [guardTrainingGroupsWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'traininggroups/:id',
        loadComponent: () => import('@components/guides/trainingGroups/trainingGroups-details/trainingGroups-details.component').then(c => c.TrainingGroupsDetailsComponent),
        canActivate: [guardTrainingGroupsWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/traininggroups/'},
            ]
        }
    },
]
